module.exports = __webpack_public_path__ + "img/showcases.43d7f34f.jpg";